import { ChangeDetectionStrategy, Component, DestroyRef, inject, output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { Button } from 'primeng/button';
import { Textarea } from 'primeng/textarea';
import { DialogEventLocationCardComponent } from '@app/main/leak-detection/dialogs/dialog-event/components/dialog-event-location-card/dialog-event-location-card.component';
import { DIALOG_EVENT_MAX_COMMENT_LENGTH } from '@app/main/leak-detection/dialogs/dialog-event/configs/dialog-event-comment.config';
import { DialogEventState } from '@app/main/leak-detection/dialogs/dialog-event/services/dialog-event-state.service';

@Component({
  selector: 'gc-dialog-event-create',
  standalone: true,
  imports: [ReactiveFormsModule, TranslateDirective, TranslatePipe, Button, Textarea, DialogEventLocationCardComponent],
  templateUrl: './dialog-event-create.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col h-full min-h-0' },
})
export class DialogEventCreateComponent {
  private readonly destroyRef = inject(DestroyRef);

  protected readonly dialogState = inject(DialogEventState);

  /** kept in the dialog state, so the note survives a trip to the location editor */
  protected readonly form = this.dialogState.commentForm;

  protected readonly maxCommentLength = DIALOG_EVENT_MAX_COMMENT_LENGTH;

  public created = output<void>();

  public cancelled = output<void>();

  protected create(): void {
    this.dialogState
      .save()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(saved => {
        if (saved) this.created.emit();
      });
  }
}
